import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { l } from '@manychat/manyui'

import NextStepSelectItem from 'common/builder/components/builder/NextStepSelectItem'
import NodePickerNextStepSelectItem from 'common/builder/components/builder/NodePickerNextStepSelectItem'
import {
  NextStepTypeNames,
  NextStepTypeIcons,
  NextStepTypeColors,
  NextStepProType,
} from 'common/builder/models/Source/constants'
import { PRIMARY_CHANNEL_NEXT_STEP_TYPES } from 'common/builder/selectors/builder/nextStepSelectors'

export default class NextStepSelect extends Component {
  static propTypes = {
    builderId: PropTypes.string,
    parentNodeId: PropTypes.string,
    sourceId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onSelectNode: PropTypes.func,
    options: PropTypes.array,
    disableNodePicker: PropTypes.bool,
    disallowBuyButton: PropTypes.bool,
    disableBuyButton: PropTypes.bool,
    isPro: PropTypes.bool,
  }

  handleSelect = (type, option) => {
    this.props.onSelect(type, option)
  }

  render() {
    const { builderId, options, disableNodePicker, onSelectNode, parentNodeId, isPro, sourceId } =
      this.props
    const showNodePickerItem =
      !disableNodePicker && options.some((o) => PRIMARY_CHANNEL_NEXT_STEP_TYPES.includes(o.type))

    /**
     * By default nodepicker receives as a sourceId id of a parent node.
     * But in some cases it could be blockId or buttonId that is inside node.
     * In this case we should override parentNodeId with provided sourceId.
     */
    const nodePickerSourceId = sourceId || parentNodeId

    return (
      <span data-onboarding-id="next-steps">
        {options.map((o) => (
          <NextStepSelectItem
            key={o.type}
            type={o.type}
            onSelect={this.handleSelect.bind(this, o.type, o)}
            icon={NextStepTypeIcons[o.type]}
            color={NextStepTypeColors[o.type]}
            title={l.getString(NextStepTypeNames[o.type])}
            proBadge={!isPro && NextStepProType.includes(o.type)}
            disabled={!!o.disabled}
            tooltip={o.tooltip ?? null}
          />
        ))}
        {showNodePickerItem && (
          <NodePickerNextStepSelectItem
            builderId={builderId}
            sourceId={nodePickerSourceId}
            onSelectNode={onSelectNode}
          />
        )}
      </span>
    )
  }
}
